import styled from 'styled-components';

export default {
  BackButton: styled.button`
    outline: none;
    background: transparent;
    border: 0;
    padding: 5px;
    font-size: 14px;
    line-height: 18px;
    color: rgba(0, 0, 0, 0.64);
    cursor: pointer;
    transition: .2s linear color;

    svg {
      margin: 2px 8px 2px 0;
      opacity: 0.4;
      transition: .2s linear opacity;
    }

    &:hover {
      color: #000;

      svg {
        opacity: 1;
      }
    }
  `,

  SectorName: styled.span`
    font-size: 18px;
    line-height: 23px;
    margin: 0 auto;
  `,
};
